import { Lightning, AppData } from '@lightningjs/sdk';
import { extractUrlFromText, convertAnchorTagsToBold } from 'support/textUtils';
import SettingsQrCodeSection from './SettingsQrCodeSection';
import QrCodeContent from './contents/QrCodeContent';

export interface AccountSectionTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Content: {
    AccountContent: typeof QrCodeContent;
    AccountQrCode: typeof SettingsQrCodeSection;
  };
}

export default class AccountSection
  extends Lightning.Component<AccountSectionTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<AccountSectionTemplateSpec>
{
  private _Content = this.getByRef('Content')!;
  private _AccountContent = this._Content.getByRef('AccountContent')!;
  private _AccountQrCode = this._Content.getByRef('AccountQrCode')!;

  get title() {
    const accContent = this._AccountContent.title;

    return [...accContent];
  }

  static override _template(): Lightning.Component.Template<AccountSectionTemplateSpec> {
    return {
      Content: {
        flex: { direction: 'column' },
        AccountContent: { type: QrCodeContent },
        AccountQrCode: { type: SettingsQrCodeSection },
      },
    };
  }

  override _active() {
    const settingsContent = AppData!.config?.login.settings;
    if (!settingsContent) return;

    const heading = settingsContent.account.title ?? '';
    const rawDescription =
      settingsContent.account.account_management.description ?? '';
    const url = extractUrlFromText(rawDescription);
    const description = convertAnchorTagsToBold(rawDescription);

    // Store values for the component
    this._AccountContent.heading = heading;
    this._AccountContent.description = description;
    this._AccountQrCode.url = url;
  }
}
